module.exports = __webpack_public_path__ + "static/img/actor-not-found.9ed70ea.svg";